/**
 * Resolves once Firebase Auth reports its first state.
 *
 * The app used to mount *inside* the onAuthStateChanged callback, which meant a
 * visitor opening a shared card — logged out, needing no auth at all — waited
 * for the Auth SDK to initialise and read its IndexedDB persistence before a
 * single pixel painted. The app now mounts immediately; only routes that
 * actually require auth await this promise, in the router guard.
 */
let settle;
let settled = false;

export const authReady = new Promise((resolve) => {
  settle = resolve;
});

export const markAuthReady = (user) => {
  if (settled) return;
  settled = true;
  settle(user);
};

/**
 * Safety net. If Firebase never calls back — offline, blocked by a network,
 * SDK failure — a protected route should fall through to the login redirect
 * rather than hang on an unresolved promise forever.
 */
if (typeof window !== "undefined") {
  setTimeout(() => markAuthReady(null), 10000);
}
